<template>
	<div class="support-video">
		<div class="video-con">
			<div class="title">
				<i class="x-icon-video"></i><span class="x-tit-con x-inline">Key Cutting Machine</span>
			</div>
			<ul class="video-list">
				<li>
					<img :src="videoImage_01" alt="Xhorse"/>
					<div class="name">XP007-Cutting Machine</div>
					<div class="time">2020-01-10 13:52:06</div>
				</li>
				<li>
					<img :src="videoImage_02" alt="Xhorse"/>
					<div class="name">HU64Key type selection</div>
					<div class="time">2019-12-13 15:34:35</div>
				</li>
				<li>
					<img :src="videoImage_03" alt="Xhorse"/>
					<div class="name">HON66Key learning</div>
					<div class="time">2019-12-13 15:33:46</div>
				</li>
				<li>
					<img :src="videoImage_04" alt="Xhorse"/>
					<div class="name">Citroen Inquire 1</div>
					<div class="time">2019-12-13 13:32:46</div>
				</li>
				<li>
					<img :src="videoImage_05" alt="Xhorse"/>
					<div class="name">Citroen Inquire 2</div>
					<div class="time">2019-12-13 15:32:20</div>
				</li>
				<li>
					<img :src="videoImage_06" alt="Xhorse"/>
					<div class="name">TOY43 Inquire</div>
					<div class="time">2019-12-13 15:31:45</div>
				</li>
				<li>
					<img :src="videoImage_07" alt="Xhorse"/>
					<div class="name">HON66Key learning</div>
					<div class="time">2019-12-13 15:33:46</div>
				</li>
				<li>
					<img :src="videoImage_08" alt="Xhorse"/>
					<div class="name">Citroen Inquire 1</div>
					<div class="time">2019-12-13 13:32:46</div>
				</li>
				<li>
					<img :src="videoImage_09" alt="Xhorse"/>
					<div class="name">XP007-Cutting Machine</div>
					<div class="time">2020-01-10 13:52:06</div>
				</li>
				<li>
					<img :src="videoImage_10" alt="Xhorse"/>
					<div class="name">TOY43 Inquire</div>
					<div class="time">2019-12-13 15:31:45</div>
				</li>
				<li>
					<img :src="videoImage_11" alt="Xhorse"/>
					<div class="name">HU64Key type selection</div>
					<div class="time">2019-12-13 13:32:46</div>
				</li>
				<li>
					<img :src="videoImage_12" alt="Xhorse"/>
					<div class="name">Citroen Inquire 2</div>
					<div class="time">2019-12-13 15:32:20</div>
				</li>
			</ul>

			<div class="find-more">
				<router-link to="">
					<div class="txt">More</div>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
    import videoImage_01 from '@/assets/resource/images/support/image_support_video_cover_01.png'
    import videoImage_02 from '@/assets/resource/images/support/image_support_video_cover_02.png'
    import videoImage_03 from '@/assets/resource/images/support/image_support_video_cover_03.png'
    import videoImage_04 from '@/assets/resource/images/support/image_support_video_cover_04.png'
    import videoImage_05 from '@/assets/resource/images/support/image_support_video_cover_05.png'
    import videoImage_06 from '@/assets/resource/images/support/image_support_video_cover_06.png'
    import videoImage_07 from '@/assets/resource/images/support/image_support_video_cover_06.png'
    import videoImage_08 from '@/assets/resource/images/support/image_support_video_cover_06.png'
    import videoImage_09 from '@/assets/resource/images/support/image_support_video_cover_06.png'
    import videoImage_10 from '@/assets/resource/images/support/image_support_video_cover_06.png'
    import videoImage_11 from '@/assets/resource/images/support/image_support_video_cover_06.png'
    import videoImage_12 from '@/assets/resource/images/support/image_support_video_cover_06.png'
    export default {
        data(){
            return {

                videoImage_01: videoImage_01,
                videoImage_02: videoImage_02,
                videoImage_03: videoImage_03,
                videoImage_04: videoImage_04,
                videoImage_05: videoImage_05,
                videoImage_06: videoImage_06,
                videoImage_07: videoImage_07,
                videoImage_08: videoImage_08,
                videoImage_09: videoImage_09,
                videoImage_10: videoImage_10,
                videoImage_11: videoImage_11,
                videoImage_12: videoImage_12
            };
        }
    }

</script>

<style scoped>
	.find-more .txt {
		width: 190px;
		height: 48px;
		background: #F7F8F8;
		font-size: 16px;
		color: #515555;
		letter-spacing: 0;
		text-align: center;
		margin: 0 auto;

	}

	.find-more {
		width: 70%;
		height: 52px;
		line-height: 48px;
	}

	.video-list > li > img {
		width: 100%;
	}

	.video-list > li > .name {
		width: 100%;
		font-family: Open SB;
		font-size: 20px;
		color: #3B3A38;
		letter-spacing: 0;
		text-align: justify;
		margin-top: 24px;
	}

	.video-list > li > .time {
		width: 100%;
		font-family: "Open Sans";
		font-size: 16px;
		color: #3B3A38;
		letter-spacing: 0;
		text-align: justify;
		margin-top: 24px;
	}

	.video-list > li:hover > .name, .video-list > li:hover > .time {
		color: #F5A623;
	}

	.video-list > li {
		width: calc((95% - 48px) / 3);
		border: none;
		height: 246px;
		margin-bottom: 64px;
		float: left;
		cursor: pointer;
	}

	.video-list > li:nth-child(2), .video-list > li:nth-child(5), .video-list > li:nth-child(8),
	.video-list > li:nth-child(11) {
		margin-left: 24px;
		margin-right: 24px;
	}

	.video-list > li:nth-last-child(1), .video-list > li:nth-last-child(2), .video-list > li:nth-last-child(3) {
		margin-bottom: 0 !important;
	}

	.video-list {
		width: 70%;
		height: 1250px;
		margin-left: 5%;
	}

	.title {
		font-size: 24px;
		color: #3B3A38;
		height: 52px;
		line-height: 52px;
	}

	.title {
		width: 100%;
		text-align: left;
		margin-top: 44px;
		margin-bottom: 44px;
	}

	.video-con {
		width: 90%;
		height: 100%;
		margin: 0 auto;
	}

	.support-video {
		width: 100%;
		height: 1546px;
	}

	.x-icon-video {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_support_video.png");
		width: 44px;
		height: 44px;
		position: relative;
		top: 15px;
		margin-right: 10px;
	}

	.x-tit-con /deep/ {
		font-family: Open Sans;
		font-size: 24px;
		color: #3B3A38;
		line-height: 52px;
	}

</style>


// WEBPACK FOOTER //
// src/components/zh-cn/support/support-videos.vue